import { render, staticRenderFns } from "./ProductRowAuction.vue?vue&type=template&id=488d55b7&scoped=true&"
import script from "./ProductRowAuction.vue?vue&type=script&lang=js&"
export * from "./ProductRowAuction.vue?vue&type=script&lang=js&"
import style0 from "./ProductRowAuction.vue?vue&type=style&index=0&id=488d55b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d55b7",
  null
  
)

export default component.exports